import { render, staticRenderFns } from "./PopupsWildcard.vue?vue&type=template&id=3a3b4c6a&"
import script from "./PopupsWildcard.vue?vue&type=script&lang=js&"
export * from "./PopupsWildcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports